import Vue from "vue";

export default {
    scopesOfPractice() {
        return Vue.http.get('information/scopes-of-practice');
    },
    reportingPeriods() {
        return Vue.http.get('information/reporting-periods')
    }
}